import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { DashboardSummary } from '../models/api.models';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class DashboardService {
  constructor(private readonly api: ApiService) {}

  summary(): Observable<DashboardSummary> {
    return this.api.get<DashboardSummary>('/dashboard');
  }
}
